import { render } from "./SalaryItem.vue?vue&type=template&id=d4d51c3c"
import script from "./SalaryItem.vue?vue&type=script&lang=js"
export * from "./SalaryItem.vue?vue&type=script&lang=js"

import exportComponent from "E:\\CODE\\jb-oa\\jb-oa-web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__